import { TslDebug } from '@/components/TslDebug';
import TslDebugArea from '@/components/TslDebugArea';
import WebGpuCanvas from '@/components/WebGpuCanvas';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import * as React from 'react';
import { Fn, positionLocal, length, abs, smoothstep, vec2, time, cos, sin, mix, vec3 } from 'three/tsl';
import { JoinNode } from 'three/webgpu';

export type Props = {};

const Circle = Fn(([p, r, t]: [p: typeof positionLocal, radius: number, thickness: number]) => {
  const distance = length(p).sub(r);
  return smoothstep(t, 0.0, abs(distance));
});

const Line = Fn(
  ([p, dir, distance, t]: [p: typeof positionLocal, direction: JoinNode, distance: number, thickness: number]) => {
    const projected = p.dot(dir);
    const clampledProjection = projected.clamp(0.0, distance);
    // return clampledProjection;
    // return mix(
    //   smoothstep(t, 0.0, length(projected.mul(dir))),
    //   vec3(1, 0, 0),
    //   smoothstep(t, 0.0, length(p.sub(clampledProjection.mul(dir))))
    // );
    return smoothstep(t, 0.0, length(p.sub(clampledProjection.mul(dir))));
  }
);

function App03(props: Props) {
  const {} = props;
  const fragmentNode = React.useMemo(() => {
    const p = positionLocal;
    const radius = 0.1;
    const thickness = 0.01;
    const circleOffset = vec2(-0.33, 0.33);
    const circleCenter = p.sub(circleOffset);
    const circle = Circle(circleCenter, radius, thickness);

    const angle = time;
    const direction = vec2(cos(angle), sin(angle));
    const radiusLine = Line(circleCenter, direction, radius, thickness);

    return mix(circle, vec3(1, 0, 0), radiusLine);
  }, []);
  return (
    <TslDebugArea style={{ backgroundColor: 'black' }}>
      {(el) => (
        <WebGpuCanvas>
          <PerspectiveCamera
            makeDefault
            fov={53}
            aspect={el.clientWidth / el.clientHeight}
            near={0.1}
            far={10}
            position={[0, 0, 1]}
          />
          <mesh name="node-mesh">
            <planeGeometry args={[5, 5]} />
            <nodeMaterial fragmentNode={fragmentNode} />
            <TslDebug meshName={'node-mesh'} />
          </mesh>
          <gridHelper rotation={[-Math.PI / 2, 0, 0]} />
          <axesHelper />
          <OrbitControls />
        </WebGpuCanvas>
      )}
    </TslDebugArea>
  );
}

export default React.memo(App03);
